// src/features/interview/components/AvatarDisplay.jsx
import React from "react";
import { motion } from "framer-motion";

const AvatarDisplay = ({ currentGif, gifVariants, isPlaying, isRecording }) => {
  return (
    <div className="w-[600px] flex flex-col items-center rounded-2xl glass-effect backdrop-blur-md shadow-lg relative overflow-hidden">
      <div className="relative w-full h-[360px] border rounded-2xl border-gray-700/50 overflow-hidden">
        {!isPlaying && !isRecording && (
          <>
            <motion.div
              className="absolute inset-0 z-0"
              animate={{
                scale: [1, 1.02, 1],
                opacity: [0.3, 0.5, 0.3],
              }}
              transition={{
                duration: 4,
                repeat: Infinity,
                ease: "easeInOut",
              }}
            >
              <div className="w-full h-full rounded-2xl border border-gray-700/50" />
            </motion.div>
            {[...Array(5)].map((_, i) => (
              <motion.div
                key={`particle-${i}`}
                className="absolute w-2 h-2 rounded-full bg-blue-400/20"
                initial={{
                  x: Math.random() * 400 - 200,
                  y: Math.random() * 400 - 200,
                }}
                animate={{
                  x: Math.random() * 400 - 200,
                  y: Math.random() * 400 - 200,
                  opacity: [0.2, 0.5, 0.2],
                }}
                transition={{
                  duration: 8 + Math.random() * 4,
                  repeat: Infinity,
                  ease: "easeInOut",
                  delay: i * 0.8,
                }}
              />
            ))}
          </>
        )}
        <div className="relative z-10 w-full h-full pointer-events-none select-none">
          {Object.keys(gifVariants).map((state) => (
            <img
              key={state}
              src={gifVariants[state]}
              alt={`AI Assistant ${state}`}
              className="absolute inset-0 w-full h-full object-center pointer-events-none"
              style={{
                objectPosition: "center",
                display: currentGif === state ? "block" : "none",
              }}
              draggable="false"
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default AvatarDisplay;
